import React, { FunctionComponent } from 'react';
import { Card, Col, Grid, PageWrapper, Row } from '@mlc/web-ui-toolkit';
import { Details, View } from './styled';

type Props = {
	header: JSX.Element;
	view: JSX.Element;
	details: JSX.Element;
	tools: JSX.Element;
};

const Profile: FunctionComponent<Props> = ({
	header,
	view,
	details,
	tools,
}) => {
	return (
		<PageWrapper>
			<Grid>
				<Row>
					<Col>{header}</Col>
				</Row>
				<Row>
					<View col="9">
						<Card border="mlcBorderThin" borderColor="mlcDove">
							{view}
						</Card>
					</View>
					<Details col="3">
						<Card border="mlcBorderThin" borderColor="mlcDove">
							{details}
						</Card>
						<Card border="mlcBorderThin" borderColor="mlcDove">
							{tools}
						</Card>
					</Details>
				</Row>
			</Grid>
		</PageWrapper>
	);
};

export default Profile;
